import React, { useEffect, useState } from "react"
import { enumUtil } from "../../../../utils/Enum"
import FormValidator from "../../../../utils/FormValidator"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import isNull from "../../../../utils/NullChecking"
import Modal from 'react-bootstrap/Modal';
import Loader from "../../../shared/Loader/Loader"
import DeleteConfirmatiom from "../../../General/DeleteConfirmation"
import Audit from "../../../General/Audit"
import ModalHeader from "../../../Setup/Shared/ModalHeader"
import ModalFooter from "../../../Setup/Shared/ModalFooter"
import UpdateReduxDropDownCodes from "../../../shared/UpdateReduxDropDownCodes"
import { useSelector } from "react-redux"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
const AddnewTimeLine = (props) => {
    let IsEditAllowed = FindSecondChild('Setup', 'Codes', 'Denial Group')?.IsAdd
    let IsDeleteAllowed = FindSecondChild('Setup', 'Codes', 'Denial Group')?.IsDeleted
    let valModal = {}
    // validation modal 
    let ValidationModal = {
        WriteOffCodeVal: "",
    }

    let WriteOff_Modal = {
        // PracticeID: 113,
        WriteOffGroup: null,
        Description: "",
        UpdatedDate: "",
        UpdatedBy: ""
    }
    const [WriteOffGroups, setWriteOffGroups] = useState()
    const [WriteOffValidationModal, setWriteOffValidationModal] = useState(ValidationModal)
    const [WriteOffSaveUpdateModal, setWriteOffSaveUpdateModal] = useState({})
    const [mainWriteOffModal, setmainWriteOffModal] = useState(WriteOff_Modal);
    const [isLoading, setIsLoading] = useState(false)
    const [del, setDel] = useState(false)
    const [isOpenAlert, setisOpenAlert] = useState(false);
    const API_URL = enumUtil.controller.General
    const { isOpenWriteOff, onClose, onDeleteRemark } = { ...props }
    const [onWriteOffSave, setonWriteOffSave] = useState(false)
    const [isOpenAudit, setisOpenAudit] = useState(false);
    const [DocumentTypeDD, SetDocumentTypeDD] = useState([])
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)

    useEffect(() => {
        if (props.WriteOffCode != null) {
            setWriteOffGroups(props.WriteOffCode)
            setDel(true)
        } else {
            if (!onWriteOffSave) {
                setWriteOffGroups(0);
                setDel(false)
            } else {
                setDel(true)
            }

        }
    }, [])
    useEffect(() => {
        if (!isNull(WriteOffGroups)) {
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/FindByID", 'post', {
                "ID": WriteOffGroups,
                "TableName": enumUtil.enumAPITableName.WriteOffGroup
            }).then((response) => {
                setIsLoading(false)
                setmainWriteOffModal(response)
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
            })
        }
    }, [WriteOffGroups])



    const handleWriteOffChange = (e) => {
        let { name, value } = e.target;
        if (process.env.REACT_APP_ISUPPERCASE === "true") {
            value = value.toUpperCase()
        }
        let modal = { ...mainWriteOffModal };
        let saveModal = { ...WriteOffSaveUpdateModal }
        modal[name] = value
        setmainWriteOffModal(modal)
        for (var property in WriteOff_Modal) {
            if (name === property) {
                saveModal[name] = value
            }
        }
        setWriteOffSaveUpdateModal(saveModal)
    }
    const WriteOffValidation = async () => {
        let ValidationModal = {
            WriteOffCodeVal: FormValidator(
                mainWriteOffModal.WriteOffGroup,
                enumUtil.enumValidationType.Required,
                'WriteOff Group',
            )
        }
        await setWriteOffValidationModal(ValidationModal)
        valModal = ValidationModal
    }
    const handleSaveWriteOff = async () => {
        await WriteOffValidation()
        let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
        if (validation) {
            NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
            return
        } else {
            setWriteOffSaveUpdateModal(WriteOffSaveUpdateModal)
            let saveModal = {
                TableName: enumUtil.enumAPITableName.WriteOffGroup,
                ID: WriteOffGroups === null ? '0' : WriteOffGroups,
                data: { ...WriteOffSaveUpdateModal },
                value: null
            }
            setIsLoading(true)
            ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
                .then((response) => {
                    // console.log("response", response)
                    if (!isNull(response.id)) {
                        setWriteOffSaveUpdateModal("")
                        NotificationHandler('Record Saved Successfully!', enumUtil.enumtoaster.success)
                        // UpdateReduxDropDownCodes(WriteOffGroups, DropDowns.WriteOffGroup, response.id, mainWriteOffModal.WriteOffGroup, mainWriteOffModal.WriteOffGroup)
                        setWriteOffGroups(response.id)
                        setonWriteOffSave(true)
                        setIsLoading(false)
                        onDeleteRemark()
                    }
                }).catch((error) => {
                    setIsLoading(false)
                    NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                })
        }
    }
    const SetRemarkCode = () => {
        if (mainWriteOffModal.WriteOffGroup != null && mainWriteOffModal.WriteOffGroup != "") {
            return (
                <p className="heading">{mainWriteOffModal.WriteOffGroup}</p>
            )
        } else {
            return (
                <p className="heading">Add New WriteOff Group</p>
            )
        }
    }
    const handleDeleteModal = () => {
        setisOpenAlert(true)
    }
    const onCloseDelete = () => {
        setisOpenAlert(false)
    }
    let DeletePopup = ""
    if (del) {
        DeletePopup = <button className={IsDeleteAllowed === false ? 'btn-icon-transparent delete-btn-disabled' : 'btn-icon-transparent '} onClick={handleDeleteModal}><span className="icon"><i className="icon-delete"></i></span><span className="title">Delete</span></button>
    }
    let DeleteConfirmation = "";
    if (isOpenAlert) {
        DeleteConfirmation = <DeleteConfirmatiom isOpenAlert={isOpenAlert} onCloseDelete={onCloseDelete} API_URL={API_URL} TableName={enumUtil.enumAPITableName.WriteOffGroup} ID={WriteOffGroups} onClose={onDeleteRemark} dropDown={DropDowns.WriteOffGroup} />
    }
    const handleAuditModal = () => {
        setisOpenAudit(true)
    }
    const onCloseAudit = () => {
        setisOpenAudit(false)
    }
    let AuditPopup = "";
    if (isOpenAudit) {
        AuditPopup = <Audit isOpenAudit={isOpenAudit} onCloseAudit={onCloseAudit} ParentID={WriteOffGroups + ""} TableName={enumUtil.enumAPITableName.WriteOffGroup} />
    }

    return (
        <React.Fragment>
            {DeleteConfirmation}
            <Modal show={isOpenWriteOff} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName="app-modal hk-modal-v1 ar-small-modal">
                {AuditPopup}
                <Modal.Body>
                    <ModalHeader HeaderName={SetRemarkCode} isOpenAudit={isOpenAudit} handleAuditModal={handleAuditModal} DeletePopup={DeletePopup} isClosed={onWriteOffSave ? onDeleteRemark : onClose} key={638} Name={'DenailCode'} IsDeleteAllowed={IsDeleteAllowed} />
                    {isLoading ? <Loader /> : null}
                    <div>
                        <div className="form-group input">
                            <label htmlFor="WriteOffGroup">WriteOff Group<span className='req'>*</span></label>
                            <div className={WriteOffValidationModal.WriteOffCodeVal ? 'form-group input error' : 'form-group input'}>
                                <input type="text"
                                    // maxLength={5}
                                    className='form-control'
                                    name="WriteOffGroup"
                                    id="WriteOffGroup"
                                    autoComplete="off"
                                    value={mainWriteOffModal.WriteOffGroup}
                                    onChange={handleWriteOffChange}
                                />
                                {WriteOffValidationModal.WriteOffCodeVal}
                            </div>
                            {/* error helperText="Error Message" */}
                        </div>
                        <div className='form-group input'>
                            <label htmlFor="Description">Description</label>
                            <textarea type="text"
                                rows={5}
                                className='form-control'
                                name="Description"
                                id="Description"
                                value={mainWriteOffModal.Description}
                                onChange={handleWriteOffChange}
                            />
                        </div>
                    </div>
                </Modal.Body>
                <ModalFooter isSaved={onWriteOffSave ? onDeleteRemark : onClose} handleSave={handleSaveWriteOff} UpdatedDate={mainWriteOffModal.UpdatedDate} UpdatedBy={mainWriteOffModal.UpdatedBy} ID={WriteOffGroups} IsEditAllowed={IsEditAllowed} />
            </Modal>
        </React.Fragment>
    )
}
export default AddnewTimeLine